const nl = {
  'filters.payoff.fortyProviders': '40 aanbieders',
  'filters.payoff.lastUpdated': 'Rentetarieven laatst bijgewerkt op {date}',
  'filters.mortgageType': 'Hypotheekvorm',
  'filters.mortgageTerm': 'Rentevaste periode',
  'filters.mortgageTerm.variable': 'Variabel',
  'filters.mortgageTerm.year': '{int} jaar',
  'filters.interestTariff': 'Rentetarief',
  'filters.interestTariff.tooltip':
    'Je kunt een hypotheek afsluiten met of zonder {nhgLink} (NHG). Dit is een garantie op hypotheken voor woningen tot {nhg} of {nhgEnergy} wanneer je dit extra bedrag volledig besteedt aan energiebesparende maatregelen. Met een NHG-hypotheek loop je als woningeigenaar minder risico en profiteer je van een rentekorting. Is de koopsom of marktwaarde van de woning hoger dan de genoemde bedragen, dan heb je een hypotheek zonder NHG. De hoogte van de rente wordt per aanbieder bepaald op basis van de verhouding tot de {marketValueLink} van de woning. Bedraagt de hypotheek bijvoorbeeld 60% van de marktwaarde van de woning dan is het rentepercentage lager dan bij een hypotheek dat 100% van de marktwaarde van de woning is. De hypotheekadviseur zoekt de beste hypotheekrente voor jouw persoonlijke situatie.',
  'filters.interestTariff.tooltip.nhgLink':
    '<a href="https://www.hypotheker.nl/begrippenlijst/huis-kopen/nationale-hypotheek-garantie/" class="text-white underline">Nationale Hypotheek Garantie</a>',
  'filters.interestTariff.tooltip.marketValueLink':
    '<a href="https://www.hypotheker.nl/begrippenlijst/huis-kopen/marktwaarde/" class="text-white underline">marktwaarde</a>',
  'filters.buildingType': 'Type bouw',
  'filters.buildingType.existing': 'Bestaande bouw',
  'filters.buildingType.new': 'Nieuwbouw',
  'filters.interestRate.applyFilters': 'Filter results',
  'filters.energyLabel': 'Energielabel',
  'filters.showFilters': 'Filteren',
  'header.mortgageProviders': 'Aanbieder',
  'header.mortgageProduct': 'Product',
  'header.interest': 'Rente',
  'item.calculateMonthlyCosts': 'Bereken je maandlasten',
  'items.button.showAll': 'Toon alle 40 resultaten'
};
export default nl;
